import { render, staticRenderFns } from "./Boxcard.vue?vue&type=template&id=4e1fc70a"
import script from "./Boxcard.vue?vue&type=script&lang=js"
export * from "./Boxcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports